import $ from 'jquery'

// keep in sync with app/models/concerns/has_column_names#validate_ledger_import_column_names
$(document).on(
  'click',
  '[data-behaviour~="validate-ledger-columns"]',
  function (e) {
    let count, id, value
    let valid = true
    $('#validate-ledger-errors').hide().find('li').hide()

    const exclusiveValues = {
      '{{account_number}}': 'account_number',
      '{{account_name}}': 'account_name',
      '{{original_name_ar}}': 'original_name_ar',
      '{{original_name_az}}': 'original_name_az',
      '{{original_name_bs}}': 'original_name_bs',
      '{{original_name_bg}}': 'original_name_bg',
      '{{original_name_ca}}': 'original_name_ca',
      '{{original_name_cs}}': 'original_name_cs',
      '{{original_name_de}}': 'original_name_de',
      '{{original_name_da}}': 'original_name_da',
      '{{original_name_el}}': 'original_name_el',
      '{{original_name_en}}': 'original_name_en',
      '{{original_name_es}}': 'original_name_es',
      '{{original_name_et}}': 'original_name_et',
      '{{original_name_fi}}': 'original_name_fi',
      '{{original_name_fr}}': 'original_name_fr',
      '{{original_name_hr}}': 'original_name_hr',
      '{{original_name_hu}}': 'original_name_hu',
      '{{original_name_id}}': 'original_name_id',
      '{{original_name_is}}': 'original_name_is',
      '{{original_name_it}}': 'original_name_it',
      '{{original_name_ja}}': 'original_name_ja',
      '{{original_name_ka}}': 'original_name_ka',
      '{{original_name_kk}}': 'original_name_kk',
      '{{original_name_km}}': 'original_name_km',
      '{{original_name_ko}}': 'original_name_ko',
      '{{original_name_lt}}': 'original_name_lt',
      '{{original_name_lv}}': 'original_name_lv',
      '{{original_name_nl}}': 'original_name_nl',
      '{{original_name_nb}}': 'original_name_nb',
      '{{original_name_pl}}': 'original_name_pl',
      '{{original_name_pt}}': 'original_name_pt',
      '{{original_name_ro}}': 'original_name_ro',
      '{{original_name_ru}}': 'original_name_ru',
      '{{original_name_se}}': 'original_name_se',
      '{{original_name_sk}}': 'original_name_sk',
      '{{original_name_sl}}': 'original_name_sl',
      '{{original_name_sr}}': 'original_name_sr',
      '{{original_name_th}}': 'original_name_th',
      '{{original_name_tr}}': 'original_name_tr',
      '{{original_name_uk}}': 'original_name_uk',
      '{{original_name_vi}}': 'original_name_vi',
      '{{original_name_zh}}': 'original_name_zh',
      '{{value}}': 'value',
      '{{credit}}': 'credit',
      '{{debet}}': 'debet',
      '{{booking_period}}': 'booking_period',
      '{{booking_date}}': 'booking_date',
    }

    for (value in exclusiveValues) {
      id = exclusiveValues[value]
      count = $('option[value="' + value + '"]').filter(':selected').length
      if (count > 1) {
        $(`#only_1_${id}`).show()
        valid = false
      }
    }

    const obligatoryValues = { '{{account_number}}': 'account_number' }

    for (value in obligatoryValues) {
      id = obligatoryValues[value]
      count = $('option[value="' + value + '"]').filter(':selected').length
      if (count === 0) {
        $(`#select_1_${id}`).show()
        valid = false
      }
    }

    // Must select either account_name XOR at least 1 original_name_xx
    const accountNameCount = $('option[value="{{account_name}}"]').filter(
      ':selected'
    ).length
    const originalNamesCount = $('option[value*="{{original_name_"]').filter(
      ':selected'
    ).length

    if (!((accountNameCount > 0) ^ (originalNamesCount > 0))) {
      $('#select_account_name_xor_original_name').show()
      valid = false
    }

    if (
      $('option[value="{{value}}"]').filter(':selected').length > 0 &&
      $('option[value="{{credit}}"], option[value="{{debet}}"]').filter(
        ':selected'
      ).length > 0
    ) {
      $('#select_value_or_debet_and_credit').show()
      valid = false
    }

    if (
      $('option[value="{{value}}"]').filter(':selected').length === 0 &&
      $('option[value="{{credit}}"], option[value="{{debet}}"]').filter(
        ':selected'
      ).length === 0
    ) {
      $('#select_value_or_debet_and_credit').show()
      valid = false
    }

    if (
      $('option[value="{{credit}}"], option[value="{{debet}}"]').filter(
        ':selected'
      ).length === 1
    ) {
      $('#select_debet_and_credit').show()
      valid = false
    }

    if ($('option[value="{{other}}"]').filter(':selected').length > 0) {
      $('#no_other').show()
      valid = false
    }

    const customValueCount = $('option')
      .filter(':selected')
      .filter(function () {
        return $(this).attr('value').substring(0, 2) !== '{{'
      }).length

    if (customValueCount > 10) {
      $('#max_custom_values').show()
      valid = false
    }

    if (!valid) {
      $('#validate-ledger-errors').show()
    }

    if (!valid) {
      e.preventDefault()
    }
    return true
  }
)
